import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import ArrowLeftIcon from '@/assets/icons/arrow-left.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';

const buttonStyles = {
    backgroundColor: Palette.white,
    color: Palette.black,
    '&:hover': {
        backgroundColor: Palette.gray.gray100,
    },
    '&:disabled': {
        backgroundColor: Palette.white,
        color: Palette.gray.gray400,
    },
};

const ImageNavigationButtons = ({ onPrev, onNext, isFirst, isLast }) => {
    return (
        <Box
            sx={{
                position: 'absolute',
                bottom: 72,
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                justifyContent: 'center',
                gap: '12px',
                '& .MuiButtonBase-root.MuiButton-root': {
                    padding: '0 !important',
                    minWidth: '44px !important',
                    height: '44px !important',
                    boxShadow: Palette.boxShadow.elevation3,
                    '&:hover': {
                        backgroundColor: Palette.gray.gray100,
                    },
                    '&:disabled': {
                        backgroundColor: Palette.white,
                        color: Palette.gray.gray400,
                    },
                },
            }}
        >
            <Button onClick={onPrev} variant='contained' disabled={isFirst} aria-label='Previous image' sx={buttonStyles}>
                <ArrowLeftIcon />
            </Button>
            <Button
                onClick={onNext}
                variant='contained'
                disabled={isLast}
                aria-label='Next image'
                sx={{
                    ...buttonStyles,
                    '& svg': {
                        transform: 'rotate(180deg)',
                    },
                }}
            >
                <ArrowLeftIcon />
            </Button>
        </Box>
    );
};

ImageNavigationButtons.propTypes = {
    onPrev: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    isFirst: PropTypes.bool.isRequired,
    isLast: PropTypes.bool.isRequired,
};

export default ImageNavigationButtons;
